import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar, Nav, Offcanvas, Collapse, Button } from "react-bootstrap";
import {
  LayoutDashboard,
  Heart,
  History,
  User,
  Award,
  LogOut,
  ChevronDown,
  ChevronRight,
  Menu,
  Utensils,
  Droplet,
  Pill,
} from "lucide-react";
import "../../assets/css/donordashboard/DonorSideBar.css";

const DonorSideBar = () => {
  const [show, setShow] = useState(false);
  const [donateOpen, setDonateOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const toggleDonate = () => setDonateOpen(!donateOpen);

  const isActive = (path) => location.pathname === path;

  // ✅ LOGOUT HANDLER
  const handleLogout = () => {
    localStorage.clear(); // sab kuch clear
    navigate("/donor"); // login page py redirect
  };

  const menuItems = [
    {
      id: "dashboard",
      title: "Dashboard",
      path: "/donor/dashboard",
      icon: <LayoutDashboard size={20} />,
    },
    {
      id: "donate-now",
      title: "Donate Now",
      icon: <Heart size={20} />,
      hasDropdown: true,
      subItems: [
        {
          id: "donate-food",
          title: "Donate Food",
          path: "/donor/donate-food",
          icon: <Utensils size={18} />,
        },
        {
          id: "donate-blood",
          title: "Donate Blood",
          path: "/donor/donate-blood",
          icon: <Droplet size={18} />,
        },
        {
          id: "donate-medicine",
          title: "Donate Medicine",
          path: "/donor/donate-medicine",
          icon: <Pill size={18} />,
        },
      ],
    },
    {
      id: "donation-history",
      title: "Donation History",
      path: "/donor/donation-history",
      icon: <History size={20} />,
    },
    {
      id: "Notification",
      title: "Notification",
      path: "/donor/notification",
      icon: <User size={20} />,
    },
    {
      id: "help-support",
      title: "Help&Support",
      path: "/donor/help&support",
      icon: <Award size={20} />,
    },
    {
      id: "rewards-badges",
      title: "Rewards & Badges",
      path: "/donor/rewards-badges",
      icon: <Award size={20} />,
      badge: "New",
    },
    {
      id: "withdraw-rewards",
      title: "Withdraw Rewards",
      path: "/donor/payout-NGO",
      icon: <Award size={20} />,
    },
    {
      id: "my-profile",
      title: "My Profile",
      path: "/donor/my-profile",
      icon: <User size={20} />,
    },
  ];

  const SidebarContent = ({ isMobile = false }) => (
    <>
      {/* Sidebar Header */}
      <div className="donor-sidebar-header">
        <div className="donor-logo-section">
          <div className="donor-logo-circle">
            <span className="donor-logo-letter">D</span>
          </div>
          <div className="donor-logo-text-section">
            <h5 className="donor-logo-title">Donor Hub</h5>
            <p className="donor-logo-subtitle">Making Difference Together</p>
          </div>
        </div>
      </div>

      {/* User Profile Section */}
      {/* <div className="donor-user-profile-section">
        <div className="donor-user-avatar-container">
          <div className="donor-user-avatar-circle">FA</div>
          <div className="donor-user-status-indicator"></div>
        </div>
        <div className="donor-user-info-section">
          <h6 className="donor-user-name">Fatima Ahmed</h6>
          <p className="donor-user-role">Generous Donor</p>
          <div className="donor-user-points">
            <Award size={14} style={{ marginRight: "4px" }} />
            <span>2,450 Points</span>
          </div>
        </div>
      </div> */}

      {/* Navigation Menu */}
      <Nav className="flex-column donor-sidebar-nav">
        {menuItems.map((item) => (
          <div key={item.id} className="donor-nav-item-wrapper">
            {item.hasDropdown ? (
              <>
                <div
                  className={`donor-nav-link ${donateOpen ? "active" : ""}`}
                  onClick={toggleDonate}
                  style={{ cursor: "pointer" }}
                >
                  <div className="donor-nav-link-content">
                    <span className="donor-nav-icon">{item.icon}</span>
                    <span className="donor-nav-text">{item.title}</span>
                  </div>
                  <span className="donor-dropdown-indicator">
                    {donateOpen ? (
                      <ChevronDown size={16} />
                    ) : (
                      <ChevronRight size={16} />
                    )}
                  </span>
                </div>

                <Collapse in={donateOpen}>
                  <div className="donor-dropdown-menu">
                    {item.subItems.map((subItem) => (
                      <Link
                        key={subItem.id}
                        to={subItem.path}
                        className={`donor-dropdown-item ${
                          isActive(subItem.path) ? "active" : ""
                        }`}
                        onClick={isMobile ? handleClose : undefined}
                      >
                        <span className="donor-dropdown-icon">
                          {subItem.icon}
                        </span>
                        <span className="donor-dropdown-text">
                          {subItem.title}
                        </span>
                      </Link>
                    ))}
                  </div>
                </Collapse>
              </>
            ) : (
              <Link
                to={item.path}
                className={`donor-nav-link ${
                  isActive(item.path) ? "active" : ""
                }`}
                onClick={isMobile ? handleClose : undefined}
              >
                <div className="donor-nav-link-content">
                  <span className="donor-nav-icon">{item.icon}</span>
                  <span className="donor-nav-text">{item.title}</span>
                </div>
                {/* {item.badge && (
                  <span className="donor-nav-badge">{item.badge}</span>
                )} */}
              </Link>
            )}
          </div>
        ))}
      </Nav>

      {/* Logout Button */}
      <div className="donor-sidebar-footer">
        <Button onClick={handleLogout} className="donor-logout-btn">
          <LogOut size={20} />
          <span>Logout</span>
        </Button>
        
      </div>
    </>
  );

  return (
    <>
      {/* Mobile Header */}
      <Navbar bg="white" className="donor-mobile-navbar d-lg-none">
        <Button
          variant="link"
          onClick={handleShow}
          className="donor-menu-toggle"
        >
          <Menu size={24} />
        </Button>
        <Navbar.Brand className="donor-mobile-brand">
          <Heart size={20} style={{ marginRight: "8px", color: "#ff6b6b" }} />
          Donor Hub
        </Navbar.Brand>
      </Navbar>

      {/* Desktop Sidebar */}
      <div className="donor-sidebar-desktop d-none d-lg-block">
        <SidebarContent />
      </div>

      {/* Mobile Offcanvas Sidebar */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        className="donor-sidebar-offcanvas"
        placement="start"
      >
        <Offcanvas.Header closeButton className="donor-offcanvas-header">
          <Offcanvas.Title>
            <Heart size={22} style={{ marginRight: "8px", color: "#ffd93d" }} />
            Donor Menu
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="donor-offcanvas-body">
          <SidebarContent isMobile={true} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DonorSideBar;